import { Container, Row, Col } from "react-bootstrap";

// Standard page wrapper: <section> → Container → Row → Col xs={12}.
// Every public page uses this shape; extracting it avoids repeating
// the five-level nesting in every page component.
export const PageSection = ({ className, id, children }) => (
  <section className={className} id={id}>
    <Container>
      <Row className="align-items-center">
        <Col xs={12}>{children}</Col>
      </Row>
    </Container>
  </section>
);
